import { jsx as _jsx } from "react/jsx-runtime";
import { App, ConfigProvider } from "antd";
import { RootStore } from "../store";
import { IconProvider } from "@ant-design/icons";
const Provider = (param)=>{
    let { children, configProvider = {}, app = {} } = param;
    return /*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        theme: {
            token: {
                colorPrimary: "#2271b1",
                borderRadius: 3
            }
        },
        ...configProvider,
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                message: {
                    top: 50
                },
                ...app,
                children: /*#__PURE__*/ _jsx(RootStore.StoreProvider, {
                    children: children
                })
            })
        })
    });
};
export { Provider };
